import { PageEvent } from './activity-tracker.types';

export interface Tab {
    id: string;
    lastActivity: number;
    visible: boolean;
    unloaded: boolean;
    persisted: boolean;
}
export interface DetectorEvent extends PageEvent {
    tabId: string;
    referrerMatch: boolean;
    timeDiff: number;
    eventUrl?: string;
}

export enum DetectorAccuracyLevel {
    LinkInteraction = 1,
    Link = 2,
    Interaction = 3,
    Focus = 4,
    Visibility = 5,
    NoVisibility = 6,
}

export interface TabEvents {
    tabId: string;
    events: PageEvent[];
}

export interface FirstNavigation {
    firstNavigation: boolean;
    lastNavigationCount: number;
    lastNavigationUrl: string;
}
